import { LayerType } from "./LayerType";

export const ViewOrderItemLayers: string[] = [LayerType.INRIX_VOLUMES];
